import React from "react";

const WallElement = ({ idx, data, handleClick }) => {
  console.log(data);
  return (
    // <div onContextMenu={(e) => e.preventDefault()} className="cardWrapper">
    <div className="cardWrapper">
      <div className="wallElCard" data-id={idx} onClick={handleClick}>
        <img src={data.img} alt={data.name} />
        {data.prize ? (
          <div className={`ribbon ${data.prize}`}>{data.prize}</div>
        ) : null}
      </div>
    </div>
  );
};

export default WallElement;
